<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="项目名称" v-bind="formItemLayout">
        <a-select
          v-decorator="[
            'project_id',
            { rules: [{ required: true, message: '请选择项目!' }] }
          ]"
          placeholder="请选择项目"
          @change="handleSelectChange"
          showSearch
          :filterOption="filterOption"
        >
          <a-select-option
            v-for="(item, i) in data"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="公寓名称" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请选择名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item
        v-if="!isUpDataCity"
        label="所在地区"
        v-bind="formItemLayout"
      >
        <area-select
          :level="2"
          type="text"
          :data="pcaa"
          v-model="cityVal"
        ></area-select>
      </a-form-item>
      <a-form-item label="详情地址" v-bind="formItemLayout">
        <a-input
          placeholder="如道路、门牌号、小区、楼栋号、单元室等"
          v-decorator="[
            'address',
            { rules: [{ required: true, message: '请填写地址!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="密码" v-bind="formItemLayout">
        <a-radio-group v-model="password_type">
          <a-radio :value="1">固定密码</a-radio>
          <a-radio :value="2">临时密码</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        v-if="password_type == 1"
        label="固定密码"
        v-bind="formItemLayout"
      >
        <a-input
          v-decorator="[
            'password',
            { rules: [{ required: true, message: '请填写密码!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="厅室" v-bind="formItemLayout">
        <a-input-number :min="1" v-model="room" />
        <span>&nbsp;&nbsp;室户</span>
      </a-form-item>
      <a-form-item
        v-show="room != '' && room > 0 ? true : false"
        v-for="(element, j) in codeList"
        :key="j"
        :label="'房间编号' + (j + 1)"
        v-bind="formItemLayout"
      >
        <a-input v-model="codeList[j]" />
      </a-form-item>
      <a-form-item label="卫生间类型" v-bind="formItemLayout">
        <a-radio-group
          @change="hideInHierarchy"
          v-decorator="[
            'washroom_type',
            { rules: [{ required: true, message: '请选择!' }] }
          ]"
        >
          <a-radio :value="1">单卫</a-radio>
          <a-radio :value="2">双卫</a-radio>
          <a-radio :value="3">三卫</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="是否为复式" v-bind="formItemLayout">
        <a-radio-group
          v-decorator="[
            'is_compound',
            { rules: [{ required: true, message: '请选择!' }] }
          ]"
        >
          <a-radio :value="1">是</a-radio>
          <a-radio :value="2">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="备注" v-bind="formItemLayout">
        <a-textarea v-model="remark"></a-textarea>
      </a-form-item>
      <a-form-item label="综合员工" v-bind="formItemLayout">
        <a-select
          showSearch
          :filterOption="filterOption"
          mode="multiple"
          v-model="customer_list"
        >
          <a-select-option
            v-for="(element, k) in adminUserList"
            :key="k"
            :value="element.id"
            >{{ element.user_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
import { pcaa } from "area-data";
import { GAO_DE_GEO_URL, GAO_DE_ADDRESS } from "../../js/map/Constant";
export default {
  inject: ["reload"],
  data() {
    return {
      typeList: [
        {
          label: "公司内部",
          value: 1
        },
        {
          label: "员工",
          value: 2
        },
        {
          label: "客户",
          value: 3
        }
      ],
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      treeExpandedKeys: [],
      hierarchy: "",
      data: [],
      treeData: [],
      radioGroup: false,
      query_field: "",
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      password: "",
      room: "",
      twoWorkOrder: 1,
      cityVal: ["上海市", "市辖区", "黄浦区"],
      province: "",
      city: "",
      area: "",
      isUpDataCity: false,
      pcaa: pcaa,
      remark: "",
      customer_list: [],
      password_type: "",
      codeList: [],
      adminUserList: [],
      latitude: "",
      longitude: "",
      detail: {}
    };
  },
  watch: {
    hierarchy() {
      // console.log(this.hierarchy);
    },
    room() {
      if (Number(this.room) > 0) {
        this.codeList.length = Number(this.room);
      }
    },
    editDetail() {
      this.detail = this.editDetail;
      this.getDetail();
      // console.log(this.detail);
    }
  },
  mounted() {
    this.getData();
    if (this.editDetail != undefined) {
      this.detail = this.editDetail;
    }
  },
  props: {
    editDetail: {}
  },
  methods: {
    getDetail() {
      this.getAdminUser(this.detail.project_id); //获取综合员工表
      this.cityVal = [this.detail.province, this.detail.city, this.detail.area]; //省市区
      this.password_type = this.detail.password_type; //密码类型
      this.room = this.detail.room; //几室户
      if (this.room != "") {
        this.codeList = this.detail.room_number.split(",");
      } //室号
      if (this.detail.customer_user_ids != "") {
        this.customer_list = this.detail.customer_user_ids
          .split(",")
          .map(Number); //综合员工
      }

      this.remark = this.detail.remark;
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            project_id: this.$form.createFormField({
              ...this.project_id,
              value: this.detail.project_id
            }),
            name: this.$form.createFormField({
              ...this.name,
              value: this.detail.name
            }),
            address: this.$form.createFormField({
              ...this.address,
              value: this.detail.address
            }),
            password: this.$form.createFormField({
              ...this.password,
              value: this.detail.password
            }),
            washroom_type: this.$form.createFormField({
              ...this.washroom_type,
              value: this.detail.washroom_type
            }),
            is_compound: this.$form.createFormField({
              ...this.is_compound,
              value: this.detail.is_compound
            })
          };
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    superior(val) {
      // console.log(val);
      this.hierarchy = val;
    },
    hideInHierarchy(e) {
      e.target.value == "1"
        ? (this.radioGroup = true)
        : (this.radioGroup = false);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, val) => {
        if (!err) {
          let address;
          this.area = this.cityVal[2];
          if (
            this.cityVal[0] == "上海市" ||
            this.cityVal[0] == "天津市" ||
            this.cityVal[0] == "北京市" ||
            this.cityVal[0] == "重庆市"
          ) {
            this.province = this.cityVal[0];
            this.city = this.cityVal[0];
          } else {
            this.province = this.cityVal[0];
            this.city = this.cityVal[1];
          }
          let url =
            this.httpsBasic.url + this.httpsBasic.clean + "House/editHouse";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            project_id: val.project_id,
            name: val.name,
            address: val.address,
            province: this.province,
            city: this.city,
            area: this.area,
            password_type: this.password_type,
            password: val.password,
            room: this.room,
            room_number:
              this.codeList.length > 0 ? JSON.stringify(this.codeList) : "",
            washroom_type: val.washroom_type,
            is_compound: val.is_compound,
            remark: this.remark,
            customer_list: JSON.stringify(this.customer_list),
            id: this.detail.id
          };
          if (this.password_type != 1) {
            delete params.password;
          }
          if (this.room == "" || this.room.length < 1) {
            delete params.room_number;
          }
          // console.log(params);
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.form.resetFields();
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    },
    handleSelectChange(value) {
      this.getAdminUser(value); //获取综合员工表
    },
    getAdminUser(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "House/getCustomerByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.adminUserList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        });
    },
    getData() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data;
            //  console.log(this.proList);
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 40px 4% 0;
  .ant-form-item {
    margin-bottom: 14px;
  }
}
</style>
<style lang="less">
.fromStyle {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
    line-height: 32px;
  }
}
</style>
